import { dropMetadataRendererABI as abi } from '@zoralabs/nft-drop-contracts'

export const DropMetadataRenderer = {
  abi,
} as const
